function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7.502,4.957L6.328,2.124C5.793,0.833,4.545,0,3.149,0H0v0.5h3.149c1.193,0,2.26,0.712,2.717,1.815l8.13,19.627 c-0.766,0.033-1.483,0.338-2.028,0.884c-0.577,0.577-0.894,1.345-0.893,2.161c0.001,1.684,1.372,3.052,3.054,3.052 c0.001,0,0.002,0,0.003,0l21.312-0.019v-0.5l-18.348,0.016V27.53h-0.334v0.005l-2.63,0.002c-0.001,0-0.002,0-0.003,0 c-1.407,0-2.553-1.145-2.554-2.552c0-0.683,0.265-1.325,0.747-1.808c0.482-0.483,1.124-0.749,1.806-0.75l19.18-0.018 c1.396-0.001,2.644-0.836,3.177-2.127l6.346-15.36L7.502,4.957z M36.022,20.093c-0.456,1.104-1.521,1.817-2.715,1.818l-18.776,0.017 L7.709,5.457l34.373-0.031L36.022,20.093z"
});

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.83 28.038",
    style: {
      enableBackground: "new 0 0 42.83 28.038"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.0450feef.svg";
export { ForwardRef as ReactComponent };